import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import { apiConstants } from "../../../utils/apiConstants";

let cancelToken;
const getAllPolls = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.GET_ALL_POLLS,
    "",
    cancelToken
  );
};

export default getAllPolls;
